module.exports = __webpack_public_path__ + "3ea0389dfabb5b09e956f1c1d73fb4d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/box.png
// module id = 3140
// module chunks = 1